import { createLocaleApi } from "@soft-db/simple-i18n";

type LocaleSchema = {
	"zoom-ctrl-needed.mac": string;
	"zoom-ctrl-needed.windows": string;
	"zoom-touch-needed": string;
};

export type SupportedLang = "en" | "fr";

const locale = {
	en: {
		"zoom-ctrl-needed.mac": "Use ⌘ + scroll to zoom the chart",
		"zoom-ctrl-needed.windows": "Use ctrl + scroll to zoom the chart",
		"zoom-touch-needed": "Use two fingers to zoom the chart",
	},
	fr: {
		"zoom-ctrl-needed.mac": "Appuyer sur ⌘ et faites défiler pour zoomer dans le graphique",
		"zoom-ctrl-needed.windows": "Appuyer sur CTRL et faites défiler pour zoomer dans le graphique",
		"zoom-touch-needed": "Utilisez deux doigts pour zoomer dans le graphique",
	},
} as const satisfies Record<SupportedLang, LocaleSchema>;

export const { useLocale, createLocale } = createLocaleApi(locale, "en");
